import { watchOnce } from '@vueuse/core';
import { useNavLoyalty } from '~/stores/navLoyalty';
import { storeToRefs } from 'pinia';

export default function onRewardsReady(cb) {
  const store = useNavLoyalty();
  const { initialized } = storeToRefs(store);

  if (initialized.value) {
    cb();
    return;
  }

  watchOnce(initialized, cb);
}
